import { useTranslation } from '@ecomm/i18n'
import { ComparisonCell } from '../ComparisonCell'
import { ComparisonRow } from '../ComparisonRow'

export function RowActiveGuard() {
  const { t } = useTranslation('maps')

  return (
    <ComparisonRow
      title={t('feature-title.active-guard')}
      description={t('feature-description.active-guard-business')}
      modalDescription={t('feature-tooltip.active-guard-business')}
    >
      <ComparisonCell included={false} />
      <ComparisonCell
        included={true}
        description={t('feature-details.active-guard-pro-time')}
      />
      <ComparisonCell
        included={true}
        description={t('feature-details.active-guard-pro-plus-time')}
      />
    </ComparisonRow>
  )
}
